import React, { FC } from 'react';
import styled from 'styled-components';
import { SubPage } from 'components/pages/ozone-design/sub-page';
import { BodyShort02, Caption01 } from 'components/styles';
import { colors, ColorDefinition, Hex } from 'ozone/colors';

const Name = styled.span`
  ${BodyShort02};
  font-weight: var(--font-weight-bold);
`;

const Variable = styled.span`
  ${Caption01};
  font-weight: 100;
`;

const HexColor = styled.span`
  ${Caption01};
`;

const Box = styled.div`
  width: 192px;
  height: 192px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: var(--layout-01);
`;

const Color: FC<{ color: ColorDefinition }> = ({ color }) => (
  <Box style={{ background: Hex.toString(color.hex) }}>
    <Name>{color.name}</Name>
    <Variable>{color.variable}</Variable>
    <HexColor>{Hex.toString(color.hex)}</HexColor>
  </Box>
);

const ColorGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Colors: FC = () => (
  <SubPage title="Colors">
    <p>
      All colors are defined with <code>RGB</code> values. They are widely used.
      We have utility method to convert to other representations when required.
      The initial palette of colors are several. We will list them here, grouped
      by hue. There are several strengths to pick from for each hue when
      possible.
    </p>
    <ColorGroup>
      {colors.map((color) => (
        <Color color={color} />
      ))}
    </ColorGroup>
  </SubPage>
);
